import React from "react";
import bgImg from "../../../assets/Rectangle05.png";

const cards = [
  {
    number: "01",
    title: "Non-Arteritic Anterior Ischemic Optic Neuropathy (NAION)",
    description:
      "A condition that occurs when blood flow to the optic nerve is reduced, potentially causing sudden vision loss.",
  },
  {
    number: "02",
    title: "Permanent Vision Impairment",
    description:
      "Some patients diagnosed with NAION experience long-term or permanent vision damage.",
  },
  {
    number: "03",
    title: "Optic Nerve Injury",
    description:
      "Damage to the optic nerve can result in lasting visual disturbances or blindness. Legal claims allege that manufacturers failed to adequately warn patients and physicians about potential risks.",
  },
];

const SemaglutideVisionLossOverview = () => {
  return (
    <section
      className="w-full font-[Quicksand] bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: `url(${bgImg})` }}
    >
      {/* Desktop + Tablet */}
      <div className="hidden md:block w-full">
        <div className="max-w-[1440px] mx-auto px-[80px] py-[60px]">

          {/* Heading */}
          <h2 className="mb-6 text-[35px] font-semibold leading-normal capitalize">
            <span className="text-[#0A1F8F]">Overview Of The </span>
            <span className="text-[#EDC14A]">
              Semaglutide Vision Loss Lawsuit
            </span>
          </h2>

          {/* Description */}
          <p className="text-[#757575] text-[18px] font-medium leading-relaxed mb-8 max-w-[1100px]">
            Semaglutide medications are part of a class of drugs known as
            GLP-1 receptor agonists, commonly prescribed for type-2 diabetes
            and weight management.
            <br />
            Popular brand-name drugs include:
            <br />• Ozempic
            <br />• Wegovy
            <br />• Rybelsus
            <br />• Trulicity
            <br />• Mounjaro
            <br />• Zepbound
            <br />
            While these medications have helped many patients manage blood
            sugar and weight, reports have emerged linking some GLP-1
            medications to Non-Arteritic Anterior Ischemic Optic Neuropathy
            (NAION) — a serious eye condition that can cause sudden and
            sometimes permanent vision loss. Individuals diagnosed with
            NAION after using these medications are now seeking legal
            review of potential claims.
          </p>

          {/* Sub Heading */}
          <h3 className="text-[#0A1F8F] text-[35px] font-semibold leading-normal mb-8">
            Lawsuits Allege That GLP-1 Drug Manufacturers Failed To Warn
            Patients About
          </h3>

          {/* Cards */}
          <div className="grid grid-cols-2 gap-8">
            {cards.map((card, index) => (
              <article
                key={card.number}
                className={`p-6 rounded-[12px] bg-white shadow-sm ${
                  index === 2 ? "col-span-2" : ""
                }`}
              >
                <span className="text-[#0A1F8F] text-[24px] font-medium block mb-2">
                  {card.number}
                </span>

                <h4 className="text-[#EDC14A] text-[18px] font-semibold mb-2">
                  {card.title}
                </h4>

                <p className="text-[#0A1F8F] text-[16px] font-medium leading-relaxed">
                  {card.description}
                </p>
              </article>
            ))}
          </div>

        </div>
      </div>

      {/* Mobile */}
      <div className="md:hidden flex flex-col gap-6 px-4 py-8">

        {/* Heading */}
        <h2 className="text-left text-[24px] font-semibold leading-[1.2] capitalize">
          <span className="text-[#0A1F8F]">Overview Of The </span>
          <span className="text-[#EDC14A]">
            Semaglutide Vision Loss Lawsuit
          </span>
        </h2>

        {/* Description */}
        <p className="text-[#757575] text-[16px] font-medium leading-relaxed">
          Semaglutide medications are part of a class of drugs known as
          GLP-1 receptor agonists, commonly prescribed for type-2 diabetes
          and weight management.
          <br />
          <br />
          Popular brand-name drugs include:
          <br />• Ozempic
          <br />• Wegovy
          <br />• Rybelsus
          <br />• Trulicity
          <br />• Mounjaro
          <br />• Zepbound
          <br />
          <br />
          While these medications have helped many patients manage blood
          sugar and weight, reports have emerged linking some GLP-1
          medications to Non-Arteritic Anterior Ischemic Optic Neuropathy
          (NAION) — a serious eye condition that can cause sudden and
          sometimes permanent vision loss.
        </p>

        {/* Sub Heading */}
        <h3 className="text-[#0A1F8F] text-[24px] font-semibold leading-[1.2] capitalize">
          Lawsuits Allege That GLP-1 Drug Manufacturers Failed To Warn
          Patients About
        </h3>

        {/* Cards */}
        <div className="flex flex-col gap-4">
          {cards.map((card) => (
            <div
              key={card.number}
              className="bg-white rounded-[12px] p-5 shadow-sm"
            >
              <span className="text-[#0A1F8F] text-[20px] font-medium block mb-2">
                {card.number}
              </span>

              <h4 className="text-[#EDC14A] text-[16px] font-semibold mb-1">
                {card.title}
              </h4>

              <p className="text-[#0A1F8F] text-[15px] font-medium leading-relaxed">
                {card.description}
              </p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default SemaglutideVisionLossOverview;